// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactSection_phoneInput__L0ckv {
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  padding: 0.75rem;
  width: 100%;
  transition: all 0.2s;
}

.ContactSection_phoneInput__L0ckv:focus-within {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.ContactSection_phoneInputInput__9ctbl {
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  font-size: 1rem;
}

.ContactSection_phoneInputInput__9ctbl:focus {
  outline: none;
}

.ContactSection_phoneInputCountry__7X3OF {
  margin-right: 0.5rem;
}

/* PrimeReact Dropdown özel stilleri */
.p-dropdown {
  border: 1px solid #d1d5db !important;
  border-radius: 0.375rem !important;
  padding: 0.75rem !important;
  width: 100% !important;
  background-color: white;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #374151;
  max-height: 48px;
  display: flex;
  align-items: center;
}

.p-dropdown:not(.p-disabled):hover {
  border-color: #9ca3af !important;
}

.p-dropdown:not(.p-disabled).p-focus {
  outline: 0 !important;
  box-shadow: 0 0 0 2px #111827;
}

.p-dropdown-panel {
  border: 1px solid #d1d5db !important;
  border-radius: 0.375rem !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
  background-color: white !important;
}

.p-dropdown-items {
  padding: 0.5rem 0 !important;
}

.p-dropdown-item {
  padding: 0.5rem 1rem;
  color: #374151;
  font-size: 1rem;
  line-height: 1.5rem;
  font-family: "Montserrat";
}

.p-dropdown-item:hover {
  background-color: #f3f4f6;
  color: #111827;
}

.p-dropdown-item.p-highlight {
  background-color: #3b82f6;
  color: white;
}

.p-dropdown-trigger {
  width: 2.5rem;
  color: #6b7280;
}

.p-dropdown-label {
  color: #374151;
  font-size: 1rem;
  line-height: 1.5rem;
  padding-left: 0;
  text-align: left;
}

.p-dropdown-label.p-placeholder {
  color: #b6b0b5;
  font-size: 1rem;
  line-height: 1.5rem;
  padding-left: 0;
  text-align: left;
  font-family: "Montserrat";
}

/* Input border stilleri - kırmızı border'ı engellemek için */
input[type="text"],
input[type="email"],
textarea {
  border: 1px solid #d1d5db !important;
  border-radius: 0.375rem !important;
  padding: 0.75rem !important;
  width: 100% !important;
  background-color: white !important;
  color: #374151 !important;
  font-size: 1rem !important;
  line-height: 1.5rem !important;
  transition: border-color 0.2s ease-in-out !important;
}

input[type="text"]:focus,
input[type="email"]:focus,
textarea:focus {
  outline: none !important;
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
}

input[type="text"]:hover,
input[type="email"]:hover,
textarea:hover {
  border-color: #60a5fa !important;
}

/* Geçersiz input stillerini sıfırla */
input:invalid,
textarea:invalid {
  border-color: #d1d5db !important;
  box-shadow: none !important;
}

input:invalid:focus,
textarea:invalid:focus {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
}

/* PhoneInput için kırmızı border'ı engellemek için */
.ContactSection_phoneInput__L0ckv {
  border: 1px solid #d1d5db !important;
  border-radius: 0.375rem !important;
  padding: 0.75rem !important;
  width: 100% !important;
  background-color: white !important;
  transition: border-color 0.2s ease-in-out !important;
}

.ContactSection_phoneInput__L0ckv:focus-within {
  outline: none !important;
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
}

.ContactSection_phoneInput__L0ckv:hover {
  border-color: #60a5fa !important;
}

.ContactSection_phoneInputInput__9ctbl {
  border: none !important;
  outline: none !important;
  background: transparent !important;
  width: 100% !important;
  font-size: 1rem !important;
  color: #374151 !important;
}

.ContactSection_phoneInputInput__9ctbl:focus {
  outline: none !important;
}

/* PhoneInput geçersiz durumlarını sıfırla */
.ContactSection_phoneInput__L0ckv:invalid {
  border-color: #d1d5db !important;
  box-shadow: none !important;
}

.ContactSection_phoneInput__L0ckv:invalid:focus-within {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
}

/* PrimeReact Dropdown için kırmızı border'ı engellemek için */
.p-dropdown {
  border: 1px solid #d1d5db !important;
  border-radius: 0.375rem !important;
  padding: 0.75rem !important;
  width: 100% !important;
  background-color: white !important;
  font-size: 1rem !important;
  line-height: 1.5rem !important;
  color: #374151 !important;
  max-height: 48px !important;
  display: flex !important;
  align-items: center !important;
  transition: border-color 0.2s ease-in-out !important;
}

.p-dropdown:not(.p-disabled):hover {
  border-color: #60a5fa !important;
}

.p-dropdown:not(.p-disabled).p-focus {
  outline: 0 !important;
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
}

/* Dropdown geçersiz durumlarını sıfırla */
.p-dropdown:invalid {
  border-color: #d1d5db !important;
  box-shadow: none !important;
}

.p-dropdown:invalid.p-focus {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ContactSection/ContactSection.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,8FAA8F;EAC9F,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;;;EAGE,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,8BAA8B;EAC9B,oDAAoD;AACtD;;AAEA;;;EAGE,wBAAwB;EACxB,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA,sCAAsC;AACtC;;EAEE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;EAEE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA,qDAAqD;AACrD;EACE,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA,8DAA8D;AAC9D;EACE,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,kCAAkC;EAClC,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA,0CAA0C;AAC1C;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D","sourcesContent":[".phoneInput {\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  padding: 0.75rem;\n  width: 100%;\n  transition: all 0.2s;\n}\n\n.phoneInput:focus-within {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.phoneInputInput {\n  border: none;\n  outline: none;\n  background: transparent;\n  width: 100%;\n  font-size: 1rem;\n}\n\n.phoneInputInput:focus {\n  outline: none;\n}\n\n.phoneInputCountry {\n  margin-right: 0.5rem;\n}\n\n/* PrimeReact Dropdown özel stilleri */\n:global(.p-dropdown) {\n  border: 1px solid #d1d5db !important;\n  border-radius: 0.375rem !important;\n  padding: 0.75rem !important;\n  width: 100% !important;\n  background-color: white;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  color: #374151;\n  max-height: 48px;\n  display: flex;\n  align-items: center;\n}\n\n:global(.p-dropdown:not(.p-disabled):hover) {\n  border-color: #9ca3af !important;\n}\n\n:global(.p-dropdown:not(.p-disabled).p-focus) {\n  outline: 0 !important;\n  box-shadow: 0 0 0 2px #111827;\n}\n\n:global(.p-dropdown-panel) {\n  border: 1px solid #d1d5db !important;\n  border-radius: 0.375rem !important;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;\n  background-color: white !important;\n}\n\n:global(.p-dropdown-items) {\n  padding: 0.5rem 0 !important;\n}\n\n:global(.p-dropdown-item) {\n  padding: 0.5rem 1rem;\n  color: #374151;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-family: \"Montserrat\";\n}\n\n:global(.p-dropdown-item:hover) {\n  background-color: #f3f4f6;\n  color: #111827;\n}\n\n:global(.p-dropdown-item.p-highlight) {\n  background-color: #3b82f6;\n  color: white;\n}\n\n:global(.p-dropdown-trigger) {\n  width: 2.5rem;\n  color: #6b7280;\n}\n\n:global(.p-dropdown-label) {\n  color: #374151;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  padding-left: 0;\n  text-align: left;\n}\n\n:global(.p-dropdown-label.p-placeholder) {\n  color: #b6b0b5;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  padding-left: 0;\n  text-align: left;\n  font-family: \"Montserrat\";\n}\n\n/* Input border stilleri - kırmızı border'ı engellemek için */\n:global(input[type=\"text\"]),\n:global(input[type=\"email\"]),\n:global(textarea) {\n  border: 1px solid #d1d5db !important;\n  border-radius: 0.375rem !important;\n  padding: 0.75rem !important;\n  width: 100% !important;\n  background-color: white !important;\n  color: #374151 !important;\n  font-size: 1rem !important;\n  line-height: 1.5rem !important;\n  transition: border-color 0.2s ease-in-out !important;\n}\n\n:global(input[type=\"text\"]:focus),\n:global(input[type=\"email\"]:focus),\n:global(textarea:focus) {\n  outline: none !important;\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;\n}\n\n:global(input[type=\"text\"]:hover),\n:global(input[type=\"email\"]:hover),\n:global(textarea:hover) {\n  border-color: #60a5fa !important;\n}\n\n/* Geçersiz input stillerini sıfırla */\n:global(input:invalid),\n:global(textarea:invalid) {\n  border-color: #d1d5db !important;\n  box-shadow: none !important;\n}\n\n:global(input:invalid:focus),\n:global(textarea:invalid:focus) {\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;\n}\n\n/* PhoneInput için kırmızı border'ı engellemek için */\n.phoneInput {\n  border: 1px solid #d1d5db !important;\n  border-radius: 0.375rem !important;\n  padding: 0.75rem !important;\n  width: 100% !important;\n  background-color: white !important;\n  transition: border-color 0.2s ease-in-out !important;\n}\n\n.phoneInput:focus-within {\n  outline: none !important;\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;\n}\n\n.phoneInput:hover {\n  border-color: #60a5fa !important;\n}\n\n.phoneInputInput {\n  border: none !important;\n  outline: none !important;\n  background: transparent !important;\n  width: 100% !important;\n  font-size: 1rem !important;\n  color: #374151 !important;\n}\n\n.phoneInputInput:focus {\n  outline: none !important;\n}\n\n/* PhoneInput geçersiz durumlarını sıfırla */\n.phoneInput:invalid {\n  border-color: #d1d5db !important;\n  box-shadow: none !important;\n}\n\n.phoneInput:invalid:focus-within {\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;\n}\n\n/* PrimeReact Dropdown için kırmızı border'ı engellemek için */\n:global(.p-dropdown) {\n  border: 1px solid #d1d5db !important;\n  border-radius: 0.375rem !important;\n  padding: 0.75rem !important;\n  width: 100% !important;\n  background-color: white !important;\n  font-size: 1rem !important;\n  line-height: 1.5rem !important;\n  color: #374151 !important;\n  max-height: 48px !important;\n  display: flex !important;\n  align-items: center !important;\n  transition: border-color 0.2s ease-in-out !important;\n}\n\n:global(.p-dropdown:not(.p-disabled):hover) {\n  border-color: #60a5fa !important;\n}\n\n:global(.p-dropdown:not(.p-disabled).p-focus) {\n  outline: 0 !important;\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;\n}\n\n/* Dropdown geçersiz durumlarını sıfırla */\n:global(.p-dropdown:invalid) {\n  border-color: #d1d5db !important;\n  box-shadow: none !important;\n}\n\n:global(.p-dropdown:invalid.p-focus) {\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"phoneInput": `ContactSection_phoneInput__L0ckv`,
	"phoneInputInput": `ContactSection_phoneInputInput__9ctbl`,
	"phoneInputCountry": `ContactSection_phoneInputCountry__7X3OF`
};
export default ___CSS_LOADER_EXPORT___;
